import React, { useState, useRef, useEffect } from 'react'
import { connect } from 'react-redux'
import onResize from 'simple-element-resize-detector'
import momenttz from '../../../component/helpers/momenttz'
import recenter from '../../../../../assets/recenter.svg'
import MarkerAlertNode from '../TripsHistory/MarkerAlertNodeHM'
import TripSpeedEvents from '../TripsHistory/TripSpeedEventsHM'
import MarkerHistoryPopup from './MarkerHistoryPopupHM'
import { useTranslation } from 'react-i18next'

const SimpleMapExample = (props) => {
	const {
		speed_unit, showTripsHistory, onClickAddress, onSelectMarker, markers, polygons, tripsGPS,
		tripsGPSSnapRoad, tripsEvents, activeTreeItem, showSnapRoad, selectedTrip, center, zoom
	} = props;

	const { t } = useTranslation('translation', { keyPrefix: 'homePage.simpleMapExampleMap' });

	const mapRef = useRef(null);
	const mapInstanceRef = useRef(null);
	const [polyline, setPolyline] = useState(null);
	const [layer, setLayer] = useState(null);
	const [mapUI, setMapUI] = useState(null);

	globalThis.g_getBoundingBox = () => {
		props.getBoundingBox();
	};

	globalThis.g_selectMarker = (device_id) => {
		onSelectMarker(device_id);
	};

	useEffect(() => {
		if (!mapInstanceRef.current) {
			const platform = new H.service.Platform({
				apikey: process.env.REACT_APP_HERE_MAPS_API_KEY
			});
			const layers = platform.createDefaultLayers();
			const baseProvider = layers.vector.normal.map.getProvider();
			const noWrapLayer = new H.map.layer.TileLayer(baseProvider, {
				worldWrap: false,
				max: 22
			});
			const MAP = new H.Map(mapRef.current, noWrapLayer, {
				center,
				zoom,
				pixelRatio: window.devicePixelRatio || 1
			});

			onResize(mapRef.current, () => MAP.getViewPort().resize());
			new H.mapevents.Behavior(new H.mapevents.MapEvents(MAP));

			const ui = H.ui.UI.createDefault(MAP, layers);
			if (document.body.clientWidth <= 991) {
				ui.getControl('mapsettings').setAlignment('bottom-left');
				ui.getControl('zoom').setAlignment('left-bottom');
			} else {
				ui.getControl('mapsettings').setAlignment('top-left');
				ui.getControl('zoom').setAlignment('right-top');
			}

			mapInstanceRef.current = MAP;
			setMapUI(ui);
			props.setMapUI(ui);
			props.setMap(MAP);
		}
	}, []);

	useEffect(() => {
		const map = mapInstanceRef.current;
		if (map) {
			if (map.getLayers().asArray().length <= 2) {
				map.setCenter(center);
				map.setZoom(zoom, true);

				const dataPoints = getMarkers(markers).map(marker =>
					new H.clustering.DataPoint(marker.position.lat, marker.position.lng, null, marker)
				);
				const clusteredDataProvider = new H.clustering.Provider(dataPoints, {
					clusteringOptions: { eps: 40, minWeight: 3 }
				});

				clusteredDataProvider.getTheme().getNoisePresentation = (noisePoint) => {
					const data = noisePoint.getData();
					const noiseMarker = new H.map.DomMarker(noisePoint.getPosition(), {
						icon: createMarker(data),
						min: map.getZoom() >= 13 ? 0 : noisePoint.getMinZoom(),
						zIndex: data.zIndex,
					});
					noiseMarker.setData(data);
					return noiseMarker;
				}

				clusteredDataProvider.addEventListener('tap', (e) => {
					const cluster = e.target;
					if (!cluster.getData()?.name && cluster.getData()?.vehiclesType !== 'equipment') {
						map.getViewPort().setPadding(100, 100, 100, 100);
						map.getViewModel().setLookAtData({
							bounds: cluster.getData().getBoundingBox()
						});
					}
				});

				map.addEventListener('pointermove', (e) => {
					if (e.target instanceof H.map.Marker || e.target instanceof H.map.Object) {
						map.getViewPort().element.style.cursor = 'pointer';
					} else {
						map.getViewPort().element.style.cursor = 'auto';
					}
				}, false);

				const btnRecenter = document.createElement('div');
				btnRecenter.setAttribute('class', 'btnRecenter H_ctl H_el');
				btnRecenter.setAttribute('onclick', 'g_getBoundingBox()');
				const img = document.createElement('img');
				img.setAttribute('class', 'svgRecenter');
				img.setAttribute('src', recenter);
				img.setAttribute('alt', 'Recenter');
				const span = document.createElement('span');
				span.setAttribute('class', 'recenterText');
				span.innerHTML = t('recenter');
				btnRecenter.appendChild(img);
				btnRecenter.appendChild(span);
				const mapMenuControl = document.querySelector('.H_l_horizontal');
				mapMenuControl && mapMenuControl.appendChild(btnRecenter);

				const objectLayer = new H.map.layer.ObjectLayer(clusteredDataProvider);
				map.addLayer(objectLayer);
				setLayer(objectLayer);
			} else {
				const dataPoints = getMarkers(markers).map(marker =>
					new H.clustering.DataPoint(marker.position.lat, marker.position.lng, null, marker)
				);
				const clusteredDataProvider = layer.getProvider();
				clusteredDataProvider.setDataPoints(dataPoints);

				if (dataPoints.length === 1 && selectedTrip) {
					const marker = getMarkers(markers)[0];
					const rootObject = clusteredDataProvider.getRootGroup().getObjects()[0];
					rootObject?.setGeometry({ lat: marker.position.lat, lng: marker.position.lng });
					rootObject?.setIcon(createMarker(marker));
				}
			}
		}
	}, [props]);

	useEffect(() => {
		const map = mapInstanceRef.current;
		if (selectedTrip && map) {
			if (map.getObjects().length) map.removeObjects(map.getObjects().filter(e => e && !(e instanceof H.map.Group)));

			const polylines = (showSnapRoad && tripsGPSSnapRoad.length && tripsGPSSnapRoad) || (tripsGPS.length && tripsGPS) || polygons || [];

			const polylineOptions = {
				strokeColor: 'rgba(66, 104, 168, 1.0)',
				lineWidth: 5,
			};
			const dashedPolylineOptions = {
				strokeColor: 'rgba(255, 255, 255, 0.5)',
				lineWidth: 3,
				lineDash: [1, 7],
				lineHeadCap: "arrow-head",
				lineTailCap: "arrow-tail",
			};

			tripsGPS.forEach((polygon) => {
				if (polygon.polygon.length > 1) {
					const lineString = new H.geo.LineString();
					polygon.polygon.forEach(elm => {
						lineString.pushPoint({ lat: elm.lat, lng: elm.lng });
					});
					const polyline = new H.map.Polyline(lineString, { style: polylineOptions });
					const dashedPolyline = new H.map.Polyline(lineString, { style: dashedPolylineOptions });

					polyline.addEventListener("pointerenter", (e) => getTripTime(e, true), true);
					polyline.addEventListener("pointermove", (e) => getTripTime(e, true), true);
					polyline.addEventListener("pointerleave", (e) => setTimeout(() => getTripTime(e, false), 1000), true);

					map.addObject(polyline);
					map.addObject(dashedPolyline);
					setPolyline(polyline);

					if (!selectedTrip.isLiveTrip) {
						map.getViewModel().setLookAtData({ bounds: polyline.getBoundingBox() });
					}
				}
			});

			const drawMarker = (src, title, coords) => {
				const divIcon = document.createElement('div');
				divIcon.setAttribute('class', 'map-narker');
				const img = document.createElement('img');
				img.setAttribute('class', 'markerImg');
				img.setAttribute('src', src);
				img.setAttribute('title', title);
				img.style.zIndex = 10000;
				img.style.opacity = 1;
				divIcon.appendChild(img);
				map.addObject(new H.map.DomMarker(coords, { icon: new H.map.DomIcon(divIcon) }));
			};

			if (polylines.length && polylines[0].polygon.length) {
				drawMarker('/images/ico/marker_start.svg', t('startTrip'), polylines[0].polygon[0]);
				if (!selectedTrip.isLiveTrip) {
					const endCoord = polylines[0].polygon[polylines[0].polygon.length - 1];
					drawMarker('/images/ico/marker_stop.svg', t('stopTrip'), endCoord);
				}
			}
		} else if (map) {
			map.getObjects().length && map.removeObjects(map.getObjects().filter(e => e && !(e instanceof H.map.Group)));
			if (polyline) {
				polyline.removeEventListener("pointerenter", (e) => getTripTime(e, true), true);
				polyline.removeEventListener("pointermove", (e) => getTripTime(e, true), true);
				polyline.removeEventListener("pointerleave", (e) => setTimeout(() => getTripTime(e, false), 1000), true);
			}
		}
	}, [tripsGPS, selectedTrip]);

	const getTripTime = (e, timeLoc) => {
		const map = mapInstanceRef.current;
		if (!map || !mapUI) return;

		const renderElements = () => {
			const object = map.getObjects().find(obj =>
				obj.type === H.map.Object.Type.DOM_MARKER && obj.getRemoteId() === "circle"
			);
			const bubble = mapUI.getBubbles().find(b =>
				b.getElement().className.includes("infoTripTime")
			);
			return { object, bubble };
		};

		if (timeLoc) {
			const position = map.screenToGeo(e.currentPointer.viewportX, e.currentPointer.viewportY);
			const arr = props.tripsGPS[0].polygon;
			let minObj = null;

			arr.forEach(({ lat, lng, timestamp }) => {
				const calcDistance = (lat1, lng1, lat2, lng2) => {
					const R = 6371e3;
					const φ1 = lat1 * Math.PI / 180;
					const φ2 = lat2 * Math.PI / 180;
					const Δφ = (lat2 - lat1) * Math.PI / 180;
					const Δλ = (lng2 - lng1) * Math.PI / 180;

					const a = Math.sin(Δφ / 2) * Math.sin(Δφ / 2) +
						Math.cos(φ1) * Math.cos(φ2) *
						Math.sin(Δλ / 2) * Math.sin(Δλ / 2);
					const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
					return R * c;
				};

				const dist = calcDistance(lat, lng, position.lat, position.lng);
				if (minObj === null || dist < minObj.distance) {
					minObj = { lat, lng, timestamp, distance: dist };
				}
			});

			const ts = momenttz(minObj.timestamp).format('hh:mm:ss a') || t('noTimeText');
			const { object, bubble } = renderElements();

			if (object) {
				object.setGeometry(position);
			} else {
				const divIcon = document.createElement('div');
				const img = document.createElement('img');

				divIcon.setAttribute('class', 'map-narker');
				img.setAttribute('src', '/images/circle.png');
				img.style.transform = 'translate(-50%, -50%)';
				img.style.width = '10px';
				img.style.height = '10px';
				divIcon.appendChild(img);

				const marker = new H.map.DomMarker(position, {
					icon: new H.map.DomIcon(divIcon, { anchor: new H.math.Point(0, 0) })
				});
				marker.setRemoteId("circle");
				map.addObject(marker);
			}

			if (bubble) {
				bubble.setPosition(position);
			} else {
				const bubbleElm = new H.ui.InfoBubble(position, {
					content: `<div class="trip-time text-center">${ts}</div>`
				});
				bubbleElm.addClass("infoTripTime");
				mapUI.addBubble(bubbleElm);
			}
		} else {
			const { object, bubble } = renderElements();
			object && map.removeObject(object);
			bubble && mapUI.removeBubble(bubble);
		}
	};

	const getMarkers = (markers) => {
		const data = [];
		markers.forEach(marker => {
			const isActive = activeTreeItem?.device_id === marker.device_id;
			let visible_icon = marker.visible_icon;
			if (!marker.position.lat || !marker.position.lng) {
				visible_icon = false;
			}
			if (!visible_icon) return;

			const img_url = `/images/vehicle_icon/${marker.icon_name}_${marker.icon_direction}${isActive ? '_active' : ''}.png`
			const equipment_img_url = '/images/vehicle_icon/' + marker.icon_name + (isActive ? '_active' : '') + '.svg'
			marker.img_url = marker.vehiclesType === 'equipment' ? equipment_img_url : img_url;
			marker.zIndex = isActive ? 10001 : 10000;

			data.push(marker);
		});
		return data;
	};

	const createMarker = (data) => {
		const html = document.createElement('div');
		const divIcon = document.createElement('div');
		const img = document.createElement('img');

		divIcon.setAttribute('class', 'map-narker');
		img.setAttribute('src', data.img_url);
		divIcon.appendChild(img);
		html.appendChild(divIcon);

		if (data.vehiclesType !== 'equipment') {
			const label = document.createElement('div');
			const div = document.createElement('div');
			const text = document.createElement('span');

			text.innerHTML = data.name;
			text.style.whiteSpace = "nowrap";
			label.setAttribute('class', `map-price-container ${data.icon_name.includes('s_van') ? 's_van' : ''}`);
			div.setAttribute('class', `map-price-marker ${data.entry.status === 'parked' ? 'parking' : data.entry.status === 'driving' ? '' : 'offline'}`);
			div.appendChild(text);
			label.appendChild(div);
			html.appendChild(label);
		}

		return new H.map.DomIcon(html, {
			anchor: new H.math.Point(10, 10),
			onAttach: (el) => el.addEventListener('click', () => g_selectMarker(data.device_id)),
			onDetach: (el) => el.removeEventListener('click', () => g_selectMarker(data.device_id)),
		});
	};

	return (
		<div
			id="map"
			style={{ position: 'relative', width: '100%', height: 'calc(100vh - 67px)' }}
			ref={mapRef}
		>
			<TripSpeedEvents device_id={activeTreeItem?.device_id} map={mapInstanceRef.current} mapUI={mapUI} />
			{showTripsHistory && getMarkers(markers)[0] && (
				<MarkerHistoryPopup
					onClickAddress={onClickAddress}
					speed_unit={speed_unit}
					marker={getMarkers(markers)[0]}
					mapUI={mapUI}
				/>
			)}
			{tripsEvents.map(item => (
				<MarkerAlertNode
					key={item.id}
					eventId={item.id}
					eventType={item.event_type}
					position={item.position}
					timestamp={item.timestamp}
					map={mapInstanceRef.current}
					mapUI={mapUI}
					polyline={polyline}
				/>
			))}
		</div>
	);
};

const mapStateToProps = ({ dashboardData }) => ({
	selectedTrip: dashboardData.selectedTrip,
	tripsGPS: dashboardData.tripsGPS,
	tripsEvents: dashboardData.tripsEvents,
	tripAlertsMarkers: dashboardData.tripAlertsMarkers,
	tripsGPSSnapRoad: dashboardData.tripsGPSSnapRoad,
	showSnapRoad: dashboardData.showSnapRoad,
	showTripsHistory: dashboardData.showTripsHistory,
});

export default connect(mapStateToProps)(SimpleMapExample);
